export const pSpoStockType = {
  OPTION_STOCK: 'OPTION_STOCK',
  TOTAL_STOCK: 'TOTAL_STOCK',
  NONE: 'NONE',
};
